import type { FC } from 'react';
import { ProductAvailabilityMessages } from '../cart-quantity-box/ProductAvailabilityMessages';
import { BaseItem } from './BaseItem';
import type { HardGoodItemProps } from './HardGoodItem';

export const ShippingProtectionItem: FC<HardGoodItemProps> = ({
    productItem,
    product,
    isSaleFinal,
    availableToSell,
}) => {
    const { productId } = productItem;

    // Override the product name for shipping protection items for Safonia Name
    const customProductItem = {
        ...productItem,
        productName: 'Safonia Shipping Protection',
    };

    return (
        <BaseItem
            id={`cart-item-shipping-protection-${productId}`}
            productItem={customProductItem}
            product={product}
            disableLink
            quantitySection={<ProductAvailabilityMessages productItem={productItem} />}
            isSaleFinal={isSaleFinal}
            availableToSell={availableToSell}
        />
    );
};
